import { forwardRef } from 'react';
import { ListSubheader } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const ItemSubheader = forwardRef(({ className, item }, ref) => {
  const styles = useStyles();

  return (
    <ListSubheader
      className={cx(styles.root, className)}
      ref={ref}
      disableGutters
      disableSticky
      data-testid={`contextMenuSubheader_${item.label}`}
    >
      {item.label}
    </ListSubheader>
  );
});

ItemSubheader.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

ItemSubheader.defaultProps = {
  className: '',
};
